import { Box, Button, Grid } from "@material-ui/core";
import clsx from "clsx";
import { useIntl } from "react-intl";
import { useStyles } from "../../../shared/styles/useStyles";
import { openExternalUrl, showWarningMessage } from "./helpers";

interface MiaProps {
  miaUrl?: string;
}

function Mia({ miaUrl }: MiaProps) {
  const intl = useIntl();
  const classes = useStyles();

  return (
    <Grid item md={5} sm={12} xs={12}>
      <Box
        className="mia-content"
        marginLeft={"auto"}
        position={"relative"}
        height={"100%"}
      >
        <Box paddingX={"30px"} className="image-form" />
        <Box className="mia-btn">
          <Button
            className={clsx(classes.btn, classes.btnAmi)}
            onClick={() => {
              if (miaUrl) {
                openExternalUrl(miaUrl);
              } else {
                showWarningMessage(intl);
              }
            }}
          >
            {intl.formatMessage({ id: "MiaHaveQuestions" })}
          </Button>
          <Box marginTop={"14px"}>
            <Button
              className={clsx(classes.btn, classes.btnAmi)}
              onClick={() => {
                alert("Aun no tiene asociado un formulario");
              }}
            >
              {intl.formatMessage({ id: "ConsultPQRSDF" })}
            </Button>
          </Box>
        </Box>
      </Box>
    </Grid>
  );
}

export default Mia;
